import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=73f6e250&scoped=true&"
import script from "./CreateModal.vue?vue&type=script&lang=ts&"
export * from "./CreateModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=73f6e250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f6e250",
  null
  
)

export default component.exports